import { defineComponent as d, toRef as p, computed as f, resolveComponent as m, openBlock as s, createElementBlock as n, normalizeClass as u, normalizeStyle as b, createVNode as _, createCommentVNode as g, renderSlot as h } from "vue";
import v from "../VIcon/VIcon.js";
import { useToggle as y } from "../../../composables/useToggle.js";
import { _ as C } from "../../../_plugin-vue_export-helper-dad06003.js";
const V = d({
  name: "VSelectable",
  emits: ["selectable:toggled"],
  components: { VIcon: v },
  props: {
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    },
    initial: {
      type: Boolean,
      required: !1,
      default: !1
    },
    selectionColor: {
      type: String,
      required: !1,
      default: "orange"
    }
  },
  setup(e, t) {
    const { state: o, toggle: l } = y(p(e, "initial"));
    return {
      cssVars: f(() => ({
        "--selection-color": `var(--hobi-color-${e.selectionColor})`
      })),
      handleClick: () => {
        l(), t.emit("selectable:toggled", o.value);
      },
      selected: o
    };
  }
});
const k = {
  key: 0,
  class: "hobi-selectable__selected-flag tw-absolute tw-top-0 tw-flex tw-justify-center tw-items-center tw-right-0"
};
function w(e, t, o, l, a, r) {
  const c = m("VIcon");
  return s(), n("div", {
    class: u([
      "hobi-selectable tw-relative overflow-hidden box-border",
      e.selected ? "hobi-selectable--selected" : "",
      e.disabled ? "hobi-selectable--disabled tw-opacity-40 tw-pointer-events-none" : ""
    ]),
    style: b(e.cssVars),
    onClick: t[0] || (t[0] = (...i) => e.handleClick && e.handleClick(...i))
  }, [
    e.selected ? (s(), n("div", k, [
      _(c, {
        symbol: "checkmark",
        height: "12px"
      })
    ])) : g("", !0),
    h(e.$slots, "default", {}, void 0, !0)
  ], 6);
}
const q = /* @__PURE__ */ C(V, [["render", w], ["__scopeId", "data-v-ef82d41e"]]);
export {
  q as default
};
